import { AnalysisNodeTypeSettings } from "./AnalysisNode";

function AnalysisNodeSettings(props) {
  const { node } = props;

  return AnalysisNodeTypeSettings[node?.data?.settings?.analysisType]({
    ...props,
  });
}

export { AnalysisNodeSettings };
